export default __webpack_public_path__ + "static/B0139-cb2218fbf0c71287efbdf31726eae2f0.png";